<template>
    <div>
        <token-banner-component v-if="tokensData" :tokens="tokensData"></token-banner-component>
        <top-bar :subtitle="subtitle" :title="title" :wtf-owner="isWtfOwner">
            <slot name="header"></slot>
        </top-bar>
        <div class="main container px-3 px-xl-6">
            <puzzle-progress-component v-if="tokensData && showMetrics" :tokens="tokensData"/>
            <slot/>
            <footer-component/>
        </div>
    </div>
</template>

<script>
import TopBar from './TopBar'
import TokenBannerComponent from '@/Components/TokenBannerComponent'
import PuzzleProgressComponent from '@/Components/PuzzleProgressComponent'
import {EventBus} from '@/Mixins/event-bus'
import FooterComponent from '@/Components/FooterComponent'

export default {
	name: 'MainLayout',

	components: {
		FooterComponent,
		PuzzleProgressComponent, TokenBannerComponent, TopBar
	},

	props: {
		title: String,
		subtitle: String,
		tokensData: {
			type: Object,
			required: false
		},
		showMetrics: Boolean,
	},

	computed: {
		isWtfOwner: function () {
			return this.$page.props.user && this.tokensData && this.tokensData.wtf ? parseFloat(this.tokensData.wtf.balance) > 0 : false
		}
	},

	created() {
		if (window.userPrivateChannel === undefined) {
			window.userPrivateChannel = window.Echo.channel(this.$page.props.session)
			window.userPrivateChannel.listen('XummMessageReceived', (e) => {
				EventBus.$emit(e.data.type, e)
			})
		}
	},
}
</script>
